import {
  TypedAbstractControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { IAccDentalDiagnosis } from '@principle-theorem/principle-core/interfaces';
import { AccProsthesisFormGroup } from './acc-prosthesis.formgroup';
import { AccTeethFormGroup } from './acc-teeth.formgroup';
import { AccToothInjuryFormGroup } from './acc-tooth-injury.formgroup';
import { AccSoftTissueFormGroup } from './acc-soft-tissue.formgroup';
import { AccJawAlveolusTmjFormGroup } from './acc-jaw-alveolus.formgroup';
import { AccDentalInjuryOtherFormGroup } from './acc-dental-injury-other.formgroup';

export class AccDiagnosisDetailsFormGroup extends TypedFormGroup<IAccDentalDiagnosis> {
  constructor() {
    super({
      teeth: new AccTeethFormGroup(),
      prosthesis: new AccProsthesisFormGroup(),
      softTissue: new AccSoftTissueFormGroup(),
      jawAlveolusTmj: new AccJawAlveolusTmjFormGroup(),
      other: new AccDentalInjuryOtherFormGroup(),
    });
  }

  patch(data: IAccDentalDiagnosis): void {
    this.patchValue(data);

    if (data.teeth?.injuries) {
      const teeth = this.controls.teeth as AccTeethFormGroup;
      teeth.toothInjuryFormArray.clear();

      data.teeth.injuries.forEach((injury) => {
        teeth.toothInjuryFormArray.push(new AccToothInjuryFormGroup(injury));
      });
    }
  }

  addToothInjuryForm(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const teeth = this.controls.teeth as AccTeethFormGroup;
    teeth.addToothInjuryForm();
  }

  removeToothInjuryForm(event: Event, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    const teeth = this.controls.teeth as AccTeethFormGroup;
    teeth.removeToothInjuryForm(index);
  }

  get toothInjuryControls(): AccToothInjuryFormGroup[] {
    const teeth = this.controls.teeth as AccTeethFormGroup;
    return teeth.toothInjuryControls;
  }

  get additionalInjuryCommentControl(): TypedAbstractControl<
    string | undefined
  > {
    const teeth = this.controls.teeth as AccTeethFormGroup;
    return teeth.additionalInjuryCommentControl;
  }

  get prosthesis(): AccProsthesisFormGroup {
    return this.controls.prosthesis as AccProsthesisFormGroup;
  }

  get softTissue(): AccSoftTissueFormGroup {
    return this.controls.softTissue as AccSoftTissueFormGroup;
  }

  get jawAlveolusTmj(): AccJawAlveolusTmjFormGroup {
    return this.controls.jawAlveolusTmj as AccJawAlveolusTmjFormGroup;
  }

  get other(): AccDentalInjuryOtherFormGroup {
    return this.controls.other as AccDentalInjuryOtherFormGroup;
  }
}
